import React from "react";
import { useState } from "react";
import { Typography, Box, Modal } from "@mui/material";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { FinanceData, FinanceDataValues } from "../../types";

interface MainInfoUpdateModalInterface {
  setFinanceData: (value: FinanceData) => void;
  closeModal: () => void;
  open: boolean;
  financeData: FinanceData;
}

const FinanceDataImportModal: React.FC<MainInfoUpdateModalInterface> = ({
  setFinanceData,
  closeModal,
  open,
  financeData,
}) => {
  const [fileName, setFileName] = useState<string | null>(null);
  const [fileContent, setFileContent] = useState<FinanceData | null>(null);

  // function isObjectMatchingType<FinanceData>(obj: any, shape: { [key in keyof FinanceData]: string }): obj is FinanceData {
  //   if (typeof obj !== 'object' || obj === null) return false;

  //   // Loop through the keys of the shape and check if the object has the expected type for each key
  //   return Object.keys(shape).every((key) => {
  //     const typedKey = key as keyof FinanceData;
  //     return typeof obj[typedKey] === shape[typedKey];
  //   });
  // }

  const interfaceTest = (obj: any) => {
    return (
      obj &&
      obj.title &&
      typeof obj.title == "string" &&
      obj.description &&
      typeof obj.description == "string" &&
      (obj.notes || obj.notes === "") &&
      typeof obj.notes == "string" &&
      obj.expectedIncome &&
      typeof obj.expectedIncome == "string" &&
      obj.expectedSavings &&
      typeof obj.expectedSavings == "string" &&
      obj.startDate &&
      typeof obj.startDate == "string" &&
      obj.endDate &&
      typeof obj.endDate == "string" &&
      obj.expectedIncome &&
      typeof obj.extraIncome == "object" &&
      obj.expenses &&
      typeof obj.expenses == "object"
    );
  };

  const expectedJsonTypes = {
    title: "string",
    description: "string",
    notes: "string",
    expectedIncome: "string",
    expectedSavings: "string",
    startDate: "string",
    endDate: "string",
    extraIncome: "object",
    expenses: "object",
  };

  function interfaceTest2(obj: any, expectedTypes: { [key: string]: string }): boolean {
    // Loop through each key in the expectedTypes map
    for (const key in expectedTypes) {
      if (expectedTypes.hasOwnProperty(key)) {
        const expectedType = expectedTypes[key];
        const actualType = typeof obj[key];
  
        // Compare the actual type of the obj's value with the expected type
        if (actualType !== expectedType) {
          console.log(`Type mismatch for key "${key}": expected ${expectedType}, but got ${actualType}`);
          return false; // If any type does not match, return false
        }
      }
    }
  
    return true; // All types match, return true
  }


  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // setFileName(file.name); // Set the selected file's name

      const reader = new FileReader();

      // Read the file as text
      reader.readAsText(file);

      // On file load, parse the JSON and save it to localStorage
      reader.onload = () => {
        try {
          const fileContent = reader.result as string;
          const parsedData = JSON.parse(fileContent);
          console.log("parsed", parsedData);
          if (interfaceTest2(parsedData,expectedJsonTypes)) {
            console.log("Object matches User interface");
            setFileName(file.name);
            setFileContent(parsedData);
          } else {
            alert("Please make sure you are selecting a valid backup.");
            closeModal()
          }

        } catch (error) {
          console.error("Error reading the file or parsing JSON", error);
          alert(
            "Error importing the file. Please ensure it's a valid JSON file."
          );
          closeModal()
        }
      };

      // Handle errors during file reading
      reader.onerror = () => {
        console.error("Error reading the file.");
        alert("Error reading the file.");
      };
    }
  };

  const replaceLocalData = () => {
    setFinanceData(fileContent as FinanceData);
    localStorage.setItem("financeData", JSON.stringify(fileContent));
    closeModal();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            padding: 2,
            mt: 10,
            backgroundColor: (theme) => theme.palette.background.paper,
            width: "95%",
            maxWidth: "400px",
            marginInline: "auto",
          }}
        >
          <input type="file" accept=".json" onChange={handleFileChange} />
          {fileName && (
            <>
              <p>
                are you sure you wish to overrite your current finance data with{" "}
                {fileName}?
              </p>
              <button onClick={replaceLocalData}>Yes</button>
            </>
          )}

          <button onClick={closeModal}>Cancel</button>
        </Box>
      </Modal>
    </>
  );
};

export default FinanceDataImportModal;

